import {
    FETCH_FEEDBKDETAILS_SUCCESS_ACTION,
    FETCH_USERS_SEARCH_SUCCESS_ACTION,
    FETCH_FEEDBACK_BY_ID_SUCCESS_ACTION
} from './action'

const initialState = {
    processing: false,
    error: false,
}

export default function (state: any = initialState, action: Function) {

    switch (action.type) {
        case FETCH_FEEDBKDETAILS_SUCCESS_ACTION:

            return {
                ...state,
                fedbckDtlsList: action.payload.rows,
                fedbckDtlsCount: action.payload.count
            }
        case FETCH_USERS_SEARCH_SUCCESS_ACTION:
            return {
                ...state,
                UsersList: action.payload.rows
            }
        case FETCH_FEEDBACK_BY_ID_SUCCESS_ACTION:
            return {
                ...state,
                FeedBckSearchList: action.payload.rows,
                FeedBckSearchCount: action.payload.count

            }
        default:
            return {
                ...state
            }
    }

}